import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, NavController, App, Platform } from 'ionic-angular';
import { TabsPage } from '../../pages/tabs/tabs';
import { RequestServiceProvider } from '../request-service/request-service';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { SocialSharing } from '@ionic-native/social-sharing';
import { LoadingProvider } from '../loading/loading';
import {PrinterServiceProvider} from "../printer-service/printer-service";
import * as moment from "moment";

/*
  Generated class for the TransactionAlertProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TransactionAlertProvider {

  public recieptObj = {};
  pdfObj = null;

  constructor(public http: HttpClient, private alertCtrl: AlertController,
              private app: App, private request: RequestServiceProvider,
              private plt: Platform, private file: File, private fileOpener: FileOpener,
              private socialSharing: SocialSharing, private loading :LoadingProvider,
              private bluetooth: PrinterServiceProvider) {

  }



  presentSuccessAlert(message, form) {
    let alert = this.alertCtrl.create({
      title: 'Transaction Successful',
      message:
        `<img src="../../assets/img/success.svg" alt="image" width="60">
      <p>${message}</p>
      `,
      buttons: [
        {
          text: 'Pay Again',
          handler: () => {
            let nav = this.app.getActiveNav();
            nav.pop();
            form.reset();
          }
        },
        {
          text: 'OK',
          handler: () => {
            let nav = this.app.getActiveNav();
            nav.setRoot(TabsPage);
          }
        }

      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  presentSuccessAlertForIncome(message) {
    let alert = this.alertCtrl.create({
      title: 'Transaction Successful',
      message:
        `
      <img src="../../assets/img/success.svg" alt="image" width="60">
      <p>${message}</p>
      `,
      buttons: [

        {
          text: 'OK',
          handler: () => {

          }
        }

      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }


  presentFailedAlert(message, form) {
    let alert = this.alertCtrl.create({
      title: 'Transaction Failed',
      message: `<img src="../../assets/img/cancel.svg" alt="image" width="60">
      <p>${message}</p>`,
      buttons: [

        {
          text: 'Retry',
          handler: () => {
            form.reset();

          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }


  presentPendingAlert(message) {
    let alert = this.alertCtrl.create({
      title: 'Transaction Pending',
      message: `<img src="../../assets/img/caution-sign.svg" alt="image" width="60">
      <p>Your transaction is pending, please check you balance before making another attempt, or call support for assistance.</p>
      `,
      buttons: [

        {
          text: 'OK',
          handler: () => {
            let nav = this.app.getActiveNav();
            nav.setRoot(TabsPage)
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }


  presentPendingAlertWithCallBack(message, cb) {
    let alert = this.alertCtrl.create({
      title: 'Transaction Pending',
      message: `<img src="../../assets/img/caution-sign.svg" alt="image" width="60">
      <p>${message}</p>
      `,
      buttons: [
        {
          text: 'OK',
          handler: () => {
            if(typeof cb === 'function') {
              cb();
            } else {
              return
            }
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }



  presentErrorAlert(message, form) {
    let alert = this.alertCtrl.create({
      title: 'Error !',
      message: `<img src="../../assets/img/cancel.svg" alt="image" width="60">
      <p>${
        message.replace(/>/g, '&gt;')
          .replace(/</g, '&lt;')
        }
      </p>`,
      buttons: [

        {
          text: 'OK',
          handler: () => {
            form.reset();
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }


  presentNormalErrorAlert(message) {
    let alert = this.alertCtrl.create({
      title: 'Error !',
      message: `<img src="../../assets/img/cancel.svg" alt="image" width="60">
      <p>${ message }</p>`,
      buttons: [

        {
          text: 'OK',
          handler: () => {

          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }


  presentNormalErrorAlertWithCallBack(message, cb) {
    let alert = this.alertCtrl.create({
      title: 'Error !',
      message: `<img src="../../assets/img/cancel.svg" alt="image" width="60">
      <p>${ message }</p>`,
      buttons: [

        {
          text: 'OK',
          handler: () => {
            if(typeof cb === 'function') {
              cb();
            } else {
              return
            }

          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }


  presentError(message) {
    let alert = this.alertCtrl.create({
      title: 'Error !',
      message: `<img src="../../assets/img/cancel.svg" alt="image" width="60">
                <p>${message.replace(/>/g, '&gt;').replace(/</g, '&lt;')}</p>
                `,
      buttons: [

        {
          text: 'OK',
          handler: () => {

          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }


  // Normal success Alert for change password...
  presentSuccessForChangePassword(message) {
    let alert = this.alertCtrl.create({
      title: 'Success!',
      message: `<img src="../../assets/img/success.svg" alt="image" width="60">
      <p>${message}</p>`,
      buttons: [

        {
          text: 'OK',
          handler: () => {
            this.request.logout();
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }


  presentComingSoonAlert(message) {
    let alert = this.alertCtrl.create({
      message: `<img src="../../assets/img/feature.svg" alt="image" width="60">
      <p>${message}</p>`,
      buttons: [

        {
          text: 'OK',
          handler: () => {

          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  presentMoveIcomeAlert(message) {
    let alert = this.alertCtrl.create({
      message: `<p>${message}</p>`,
      buttons: [

        {
          text: 'Yes',
          handler: () => {
            this.moveIncome();
          }
        },
        {
          text: 'No',
          handler: () => {

          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  presentNormalAlert(message) {
    let alert = this.alertCtrl.create({
      message: ` <p>${message}</p>`,
      buttons: [

        {
          text: 'OK',
          handler: () => {

          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }


  presentNormalSuccessAlert(message) {
    let alert = this.alertCtrl.create({
      message: `<img src="../../assets/img/success.svg" alt="image" width="60">
      <p>${message}</p>`,
      buttons: [

        {
          text: 'OK',
          handler: () => {
            let nav = this.app.getActiveNav();
            nav.setRoot(TabsPage)
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  presentNormalSuccessAlertWithCallBack(message, cb) {
    let alert = this.alertCtrl.create({
      message: `<img src="../../assets/img/success.svg" alt="image" width="60">
      <p>${message}</p>`,
      buttons: [

        {
          text: 'OK',
          handler: () => {
            if(typeof cb === 'function') {
              cb();
            } else {
              return
            }
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  presentMposAlert(message: string, cb: () => void, onDismiss: () => void) {
    let alert = this.alertCtrl.create({
      message,
      buttons: [
        {
          text: 'OK',
          handler: () => {
           cb();
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
    alert.dismiss(onDismiss)
  }


  presentRecieptAlert({reciept, logoId}, onDismiss: () => void) {

    let alert = this.alertCtrl.create({
      message: `

         <strong><h4 class="receipt__head">Receipt</h4></strong>

        <strong> <p class="title">Transaction Details</p></strong>

        ${this.extractReceitDetails(reciept)}
      `,
      buttons: [

        {
          text: 'Share',
          handler: () => {
            this.share(this.extractReceitDetails(reciept).replace(/<\/?[^>]+(>|$)/g, ""));
          }
        },
        {
          text: 'Print',
          handler: () => {
            let count = Number(localStorage.getItem('print_count'));

            // this.print(reciept, logoId); 8034
            //  this.print(reciept, '8034', 'customer');
            if(count && typeof count === 'number') {
              for( let i = 0; i < count; i++) {
                if(i === 0) {
                  this.print(reciept, logoId, 'customer');
                }else if(i === 1) {
                  this.print(reciept, logoId, 'account');
                }else if(i === 2) {
                  this.print(reciept, logoId, 'audit');
                }else {
                  this.print(reciept, logoId, 'default');
                }
              }
            }else {
              count = 2 ;
              for( let i = 0; i < count; i++) {
                if(i === 0 ) {
                  this.print(reciept, logoId, 'customer');
                }else if(i === 1 ) {
                  this.print(reciept, logoId, 'account');
                }
              }
            }

          }
        }
      ],
      cssClass: 'alertCustomCss'
    });
    alert.present();
    alert.onDidDismiss(onDismiss)
  }

  print(reciept, logoId, type) {
    if(logoId) {
      this.bluetooth.printImage(`${this.formatReceiptForPrinter(reciept, type)}`, logoId);
    }else {
      this.bluetooth.printText(`${this.formatReceiptForPrinter(reciept, type)}`)
    }
  }




  extractReceitDetails(receipt){
    const copyReceipt = this.prepRecieptObj(receipt);
    let template = " ";
    Object.entries(copyReceipt).forEach(([key, value]) => {
      template = ` ${template} <strong><p> <span>${this.camelCaseToWords(key)} : </span> <span class="right"> ${value}</span></p></strong> \n`
    });
    return  template;
  }

  formatReceiptForPrinter(receipt, type) {
    const copyReceipt = this.prepRecieptObj(receipt);

    let  template = "Transaction Details \n\n";

    switch (type) {
      case 'customer' :
        template += "******* CUSTOMER COPY ******* \n\n";
        break;
      case 'account' :
        template += "******* ACCOUNT COPY ******* \n\n";
        break;
      case 'audit' :
        template += "******* AUDIT COPY ******* \n\n";
        break;
      default:
        template += "******* SERVICE COPY ******* \n\n";

    }

    Object.entries(copyReceipt).forEach(([key, value]) => {
      template = `${template} ${this.camelCaseToWords(key)} : ${value} \n`
    });
    return `${template}\n Sign ................... \n\n\n ............................... \n\n`;
  }

  moveIncome () {
    this.loading.presentLoading('Processing...');
    this.request.postMoveIncome().subscribe(
      data => {
        // console.log(data)
        if(data.json().code === "0000"){
          this.loading.loader.dismiss().catch(()=>{});
          this.presentMoveIcomeAlert('Income Moved Successfully')
        }else{
          this.presentNormalErrorAlert(data.json().message);
        }
      },
      error => {
        this.presentNormalErrorAlert(error.json().message);
        this.loading.loader.dismiss().catch(()=>{})
      }
    )
  }

  camelCaseToWords(camelCase){
    return camelCase
      .replace(/([A-Z])/g, (match) => ` ${match}`)
      .replace(/^./, (match) => match.toUpperCase());
  }

  naira(number) {
    return Number(number || 0).toLocaleString("en-NG", {
      currency: "NGN",
      currencyDisplay: "symbol",
      style: "currency"
    });
  }


  prepRecieptObj (receipt) {
    for (const prop in receipt) {
      if(receipt[prop] === null){
        delete receipt[prop];
      }
    }
    const copyReceipt = {...receipt};
    copyReceipt.date = moment(receipt.date).format("MM/DD/YYYY HH:mm a");
    //copyReceipt.amount =   this.naira(receipt.amount);
    copyReceipt.amount = `NGN ${receipt.amount.toLocaleString()}`;
    return copyReceipt ;
  }

  stripUnwantedObjFields(obj, arrayOfFields){
    if(arrayOfFields.length == 0){
      return obj;
    }

    for(let i = 0; i < arrayOfFields.length; i++ ){
      delete obj[arrayOfFields[i]]
    }
    return obj;
  }


  share(msg){
    this.socialSharing.share(msg)
      .then(() => {
        // Sharing via email is possible
      }).catch(() => {
      // Sharing via email is not possible
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/transaction-alert/transaction-alert.ts